import useReveal from '../hooks/useReveal';
import useLazyVideo from '../hooks/useLazyVideo';
import './Galeria.css';
import dojoClip from '../assets/dojo-clip.mp4';
import dojoPoster from '../assets/dojo-clip-poster.jpg';
import p1 from '../assets/toloza.jpeg';
import p2 from '../assets/ninopeq.jpeg';
import p3 from '../assets/simon.jpeg';
import p4 from '../assets/nino.jpeg';
import p5 from '../assets/lucia.jpeg';
import p6 from '../assets/isabellaGerardino.jpeg';
import p7 from '../assets/yehuda.jpeg';
import p8 from '../assets/cristianMedalla.jpeg';
import p9 from '../assets/nortePodio1.webp';
import p10 from '../assets/nortePodio2.webp';
import p11 from '../assets/nortePodio3.webp';

const shots = [p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11];

export default function Galeria() {
  const gridRef = useReveal();
  const clipRef = useLazyVideo();

  return (
    <section id="podio" className="galeria">
      <div className="galeria__header">
        <div>
          <div className="galeria__eyebrow">
            <span className="galeria__rule" />
            <span>Resultados · Federación Colombiana</span>
          </div>
          <h2 className="galeria__title">
            EL <span className="text-red">PODIO</span>
          </h2>
        </div>
        <p className="galeria__lead serif">
          El trabajo del dojo se mide en el tatami. Cristian David compite con la
          Selección Colombia; el resto de nuestros atletas defiende a Norte de
          Santander.
        </p>
      </div>

      <div ref={gridRef} className="galeria__grid reveal">
        <figure className="galeria__tile galeria__tile--video galeria__tile--col">
          <video ref={clipRef} data-src={dojoClip} poster={dojoPoster} preload="none" muted loop playsInline />
          <figcaption className="galeria__cap">
            <span className="galeria__flag galeria__flag--col" />
            <span className="galeria__cap-tag galeria__cap-tag--col">
              Cristian David · Selección Colombia
            </span>
          </figcaption>
        </figure>

        {shots.map((src, i) => (
          <figure className="galeria__tile" key={i}>
            <img src={src} alt="Atleta del Centro de Entrenamiento Kamae en competencia oficial" loading="lazy" />
            <figcaption className="galeria__cap">
              <span className="galeria__flag galeria__flag--nds" />
              <span className="galeria__cap-tag">Selección Norte de Santander</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
